import { Table } from '@table/classes/table.class';
import { AuthService } from '@app/services';
import { Paginator } from '@app/classes';
import { ChangeRequestTemplate } from '@models/change-requests/change-request-template.model';
import {
    NameColumn,
    StatusColumn,
    RequestCountColumn,
} from '@change-requests/services/tables/change-request-templates-table/columns';

export class ChangeRequestTemplatesIndexTable extends Table {
    links = true;

    constructor(protected auth: AuthService) {
        super(auth);
        this.boot();
    }

    setColumns(): void {
        this.addColumns(new NameColumn(), new StatusColumn(), new RequestCountColumn());
    }

    setDataSource(): void {
        this.paginator = new Paginator(ChangeRequestTemplate.query());
    }
}
